// extracted by mini-css-extract-plugin
export default {"container":"n8mWuk","heading":"eupcXf","content":"ovwzi_","component":"OmH5dF"};